(function () {
  'use strict';

  if (!window.__excludePublishers) return;

  var META_CACHE_PREFIX = 'kitaboo-product-meta:v1:';
  var META_CACHE_TTL = 30 * 60 * 1000;
  var FETCH_CONCURRENCY = 8;
  var updateTimer = null;
  var metaCache = new Map();
  var lastAppliedToken = 0;

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function isExclusionGridActive() {
    var grid = document.getElementById('product-grid');
    return !!(grid && grid.dataset.exclusionPagination === 'true');
  }

  function usesLargeCollectionFacetCounts() {
    return !!(
      window.__excludePublishers &&
      document.querySelector('[data-large-collection="true"]') &&
      window.KitabooExclusionPagination
    );
  }

  function usesNativeStorefrontFacets() {
    return isExclusionGridActive() && !document.querySelector('[data-large-collection="true"]');
  }

  function shouldRecalculateFacetCounts() {
    if (usesNativeStorefrontFacets()) return false;
    if (isExclusionGridActive()) return true;
    var grid = document.getElementById('product-grid');
    return !!(grid && grid.dataset.kitabooHydrated === 'filtered' && window.__excludePublishers);
  }

  function stripCountSuffix(text) {
    return String(text || '').replace(/\s*\(\d+\+?\)\s*$/, '').trim();
  }

  function readMetaCache(handle) {
    if (metaCache.has(handle)) return metaCache.get(handle);
    try {
      var raw = sessionStorage.getItem(META_CACHE_PREFIX + handle);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || Date.now() - data.ts > META_CACHE_TTL) return null;
      metaCache.set(handle, data.meta);
      return data.meta;
    } catch (error) {
      return null;
    }
  }

  function writeMetaCache(handle, meta) {
    metaCache.set(handle, meta);
    try {
      sessionStorage.setItem(
        META_CACHE_PREFIX + handle,
        JSON.stringify({ meta: meta, ts: Date.now() })
      );
    } catch (error) {
      /* ignore quota errors */
    }
  }

  function fetchProductMeta(handle) {
    var cached = readMetaCache(handle);
    if (cached) return Promise.resolve(cached);

    return fetch('/products/' + encodeURIComponent(handle) + '?view=kitaboo-meta', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.ok ? res.text() : null;
      })
      .then(function (text) {
        if (!text) return null;
        try {
          var meta = JSON.parse(text.trim());
          if (meta && meta.handle) {
            writeMetaCache(meta.handle, meta);
            return meta;
          }
        } catch (error) {
          return null;
        }
        return null;
      })
      .catch(function () {
        return null;
      });
  }

  function fetchMetaBatch(handles) {
    var unique = [];
    var seen = new Set();
    handles.forEach(function (handle) {
      if (!handle || seen.has(handle)) return;
      seen.add(handle);
      unique.push(handle);
    });

    var results = [];
    var index = 0;

    function runNext() {
      if (index >= unique.length) return Promise.resolve(results);
      var batch = unique.slice(index, index + FETCH_CONCURRENCY);
      index += FETCH_CONCURRENCY;
      return Promise.all(
        batch.map(function (handle) {
          return fetchProductMeta(handle);
        })
      ).then(function (batchResults) {
        batchResults.forEach(function (meta) {
          if (meta) results.push(meta);
        });
        return runNext();
      });
    }

    return runNext();
  }

  function buildCombinedPath(meta) {
    if (meta.combined) return String(meta.combined).trim();
    var parts = [meta.l1, meta.l2, meta.l3, meta.l4].filter(function (part) {
      return part && String(part).trim();
    });
    return parts.join('|');
  }

  function buildFacetCountMaps(products, metas) {
    var metaByHandle = new Map();
    metas.forEach(function (meta) {
      if (meta && meta.handle) metaByHandle.set(meta.handle, meta);
    });

    var maps = {
      publisher: Object.create(null),
      category: Object.create(null),
      subCategory: Object.create(null),
      author: Object.create(null),
      bookType: Object.create(null)
    };

    products.forEach(function (product) {
      var vendorKey = normalize(product.vendor);
      if (vendorKey) {
        maps.publisher[vendorKey] = (maps.publisher[vendorKey] || 0) + 1;
      }

      var meta = metaByHandle.get(product.handle) || {
        handle: product.handle,
        vendor: product.vendor,
        l1: '',
        l2: '',
        l3: '',
        l4: '',
        combined: '',
        author: '',
        bookType: ''
      };

      if (!meta.l1 && product.l1) meta.l1 = product.l1;
      if (!meta.l2 && product.l2) meta.l2 = product.l2;
      if (!meta.l3 && product.l3) meta.l3 = product.l3;
      if (!meta.l4 && product.l4) meta.l4 = product.l4;

      var categoryValue = meta.productType || meta.l1;
      if (categoryValue) {
        var categoryKey = normalize(categoryValue);
        maps.category[categoryKey] = (maps.category[categoryKey] || 0) + 1;
      }

      var combinedPath = buildCombinedPath(meta);
      if (combinedPath) {
        var subKey = normalize(combinedPath);
        maps.subCategory[subKey] = (maps.subCategory[subKey] || 0) + 1;
      }

      if (meta.author) {
        var authorKey = normalize(meta.author);
        maps.author[authorKey] = (maps.author[authorKey] || 0) + 1;
      }

      if (meta.bookType) {
        var bookTypeKey = normalize(meta.bookType);
        maps.bookType[bookTypeKey] = (maps.bookType[bookTypeKey] || 0) + 1;
      }
    });

    return maps;
  }

  function detectFacetDimension(summaryText) {
    var text = String(summaryText || '').trim().toLowerCase();
    if (text.indexOf('publisher') === 0) return 'publisher';
    if (text.indexOf('sub category') === 0 || text.indexOf('sub-category') === 0) return 'subCategory';
    if (text.indexOf('category') === 0) return 'category';
    if (text.indexOf('author') === 0) return 'author';
    if (text.indexOf('book type') === 0 || text.indexOf('booktype') === 0) return 'bookType';
    return null;
  }

  function resolveFacetCount(dimension, input, spanLabel, maps) {
    if (!dimension || !maps[dimension]) return null;

    var valueKey = normalize(input.value || '');
    var labelKey = normalize(stripCountSuffix(spanLabel));
    var map = maps[dimension];

    if (valueKey && map[valueKey] != null) return map[valueKey];
    if (labelKey && map[labelKey] != null) return map[labelKey];

    if (dimension === 'subCategory' && valueKey) {
      var pipeParts = valueKey.split('|').map(function (part) {
        return normalize(part);
      });
      if (pipeParts.length) {
        var rebuilt = pipeParts.join('|');
        if (map[rebuilt] != null) return map[rebuilt];
      }
    }

    return 0;
  }

  function updateFacetCheckbox(input, count) {
    var isLcFilter = !!(input.dataset.lcFilter || (input.closest && input.closest('.lc-filter')));
    if (isLcFilter) return;
    var li = input.closest('li');
    var span = li ? li.querySelector('span[aria-hidden="true"]') : null;
    var hidden = li ? li.querySelector('span.visually-hidden') : null;
    var labelText = stripCountSuffix(span ? span.textContent : input.value);
    var suffix = ' (' + count + ')';

    if (span) span.textContent = labelText + suffix;
    if (hidden) hidden.textContent = labelText + suffix;

    var disabled = count === 0 && !input.checked;
    input.disabled = disabled;
    input.classList.toggle('disabled', disabled);

    var hideZeroCount = usesLargeCollectionFacetCounts();

    if (li) {
      if (!isLcFilter && hideZeroCount) {
        li.style.display = disabled ? 'none' : '';
      } else if (!isLcFilter) {
        li.style.display = '';
      } else {
        li.style.display = '';
      }
      li.classList.toggle('facet-checkbox--disabled', disabled);
    }

    var mobileLabel = input.closest('label.mobile-facets__label');
    if (mobileLabel) {
      mobileLabel.classList.toggle('mobile-facets__label--disabled', disabled);
      var mobileItem = mobileLabel.closest('.mobile-facets__item');
      if (mobileItem) {
        if (!isLcFilter && hideZeroCount) {
          mobileItem.style.display = disabled ? 'none' : '';
        } else if (!isLcFilter) {
          mobileItem.style.display = '';
        } else {
          mobileItem.style.display = '';
        }
      }
    }
  }

  function removeSubCategoryTrees() {
    document.querySelectorAll('.facets__disclosure-vertical.combined-filter').forEach(function (details) {
      details.querySelectorAll('ul.tree-level').forEach(function (tree) {
        tree.parentNode.removeChild(tree);
      });
      details.classList.remove('combined-filter');
      var hiddenList = details.querySelector('ul.list-unstyled[style*="display: none"], ul.list-unstyled[style*="display:none"]');
      if (hiddenList) hiddenList.style.display = '';
    });

    document.querySelectorAll('.mobile-facets__submenu.mobile-combined-filter').forEach(function (container) {
      container.classList.remove('mobile-combined-filter');
      var tree = container.querySelector('ul.mobile-tree-level');
      if (tree) tree.parentNode.removeChild(tree);
      var oldList = container.querySelector('ul.mobile-facets__list');
      if (oldList) oldList.style.display = '';
    });
  }

  function applyFacetCounts(maps) {
    document.querySelectorAll('.facets__disclosure-vertical.js-filter, .facets__disclosure-vertical.lc-filter').forEach(function (details) {
      var summary = details.querySelector('summary span');
      var dimension = detectFacetDimension(summary ? summary.textContent : '');
      if (!dimension) return;

      details.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        var li = input.closest('li');
        var span = li ? li.querySelector('span[aria-hidden="true"]') : null;
        var count = resolveFacetCount(
          dimension,
          input,
          span ? span.textContent : '',
          maps
        );
        if (count == null) return;
        updateFacetCheckbox(input, count);
      });
    });

    document.querySelectorAll('.mobile-facets__details').forEach(function (details) {
      var summary = details.querySelector('summary .mobile-facets__highlight') ||
        details.querySelector('summary span') ||
        details.querySelector('summary');
      var dimension = detectFacetDimension(summary ? summary.textContent : '');
      if (!dimension) return;

      details.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        var item = input.closest('.mobile-facets__item');
        var span = item ? item.querySelector('span[aria-hidden="true"]') : null;
        var count = resolveFacetCount(
          dimension,
          input,
          span ? span.textContent : '',
          maps
        );
        if (count == null) return;
        updateFacetCheckbox(input, count);
      });
    });

    removeSubCategoryTrees();
    document.dispatchEvent(new CustomEvent('kitaboo:rebuild-subcategory-tree'));
  }

  function scheduleFacetCountUpdate(detail) {
    if (!shouldRecalculateFacetCounts()) return;
    if (updateTimer) clearTimeout(updateTimer);
    var token = Date.now();
    lastAppliedToken = token;

    updateTimer = setTimeout(function () {
      updateTimer = null;

      if (usesLargeCollectionFacetCounts()) {
        var paginationApi = window.KitabooExclusionPagination;
        paginationApi.ensureBaseIndexForFacetCounts()
          .then(function () {
            if (token !== lastAppliedToken) return null;
            return paginationApi.computeSidebarFacetCountMaps();
          })
          .then(function (maps) {
            if (token !== lastAppliedToken || !maps) return;
            applyFacetCounts(maps);
            document.dispatchEvent(new CustomEvent('kitaboo:facet-counts-updated', { detail: { maps: maps } }));
          });
        return;
      }

      var indexApi = window.KitabooExclusionPagination;
      var activeIndex = indexApi && indexApi.getActiveIndex ? indexApi.getActiveIndex() : null;
      var products = (detail && detail.products) ||
        (activeIndex ? activeIndex.products : null) ||
        [];

      if (!products.length) {
        if (!activeIndex || !activeIndex.complete) return;
        applyFacetCounts({
          publisher: Object.create(null),
          category: Object.create(null),
          subCategory: Object.create(null),
          author: Object.create(null),
          bookType: Object.create(null)
        });
        return;
      }

      var handles = products.map(function (product) {
        return product.handle;
      });

      fetchMetaBatch(handles).then(function (metas) {
        if (token !== lastAppliedToken) return;
        var maps = buildFacetCountMaps(products, metas);
        applyFacetCounts(maps);
        document.dispatchEvent(new CustomEvent('kitaboo:facet-counts-updated', { detail: { maps: maps } }));
      });
    }, 250);
  }

  document.addEventListener('kitaboo:visible-index-updated', function (event) {
    scheduleFacetCountUpdate(event.detail || null);
  });

  document.addEventListener('lc-filters:rendered', function () {
    scheduleFacetCountUpdate(null);
  });

  function restoreNativeFacetVisibility() {
    if (!usesNativeStorefrontFacets()) return;
    document.querySelectorAll('#FacetsWrapperDesktop li, .mobile-facets__item').forEach(function (el) {
      el.style.display = '';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    restoreNativeFacetVisibility();
    if (!shouldRecalculateFacetCounts()) return;
    var indexApi = window.KitabooExclusionPagination;
    if (indexApi && indexApi.getActiveIndex) {
      var index = indexApi.getActiveIndex();
      if (index && index.products && index.products.length) {
        scheduleFacetCountUpdate({ products: index.products });
      }
    }
  });
})();
